export default function nl2br(text) {    
    if (typeof text == 'string') {
        return text.replace(/\n/g, "<br />");
    } else {
        return ""; 
    }
}